import { IsString, IsNotEmpty, IsArray, IsOptional } from 'class-validator';
import { CreateProspectDataDto } from './create-prospect.dto';
import { ProspectOwnerDto } from './prospect.dto';

export class CreateProspectsBatchDto {
    @IsString()
    @IsNotEmpty()
    userOrganizationId: string;

    @IsArray()
    data: CreateProspectDataDto[];

    @IsOptional()
    sourceId?: string;

    @IsOptional()
    owner?: ProspectOwnerDto;

    @IsOptional()
    assignToCampaign?: string;

    constructor(createProspectsBatchDto: CreateProspectsBatchDto) {
        this.userOrganizationId = createProspectsBatchDto.userOrganizationId;
        this.data = createProspectsBatchDto.data;
        this.sourceId = createProspectsBatchDto.sourceId;
        this.owner = createProspectsBatchDto.owner;
        this.assignToCampaign = createProspectsBatchDto.assignToCampaign;
    }
}
